/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Scim_Token_Rotated_DescInputs */



/**
* | output |
* | --- |
* | "The SCIM token was replaced. The previous token stopped working immediately and the identity provider needs the new one." |
*
* @param {Audit_Details_Scim_Token_Rotated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_scim_token_rotated_desc = /** @type {((inputs?: Audit_Details_Scim_Token_Rotated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Scim_Token_Rotated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das SCIM-Token wurde ersetzt. Das vorherige Token ist sofort ungültig, der Identitätsanbieter benötigt das neue.")
	return /** @type {LocalizedString} */ ("The SCIM token was replaced. The previous token stopped working immediately and the identity provider needs the new one.")
});